import { Switch } from "@/components/ui/switch";

export const QuickMargin = ({ onPick, testId, disabled = false, values = [10, 20, 30] }) => (
  <div className="mt-1 flex gap-1">
    {values.map((v) => (
      <button key={v} type="button" disabled={disabled} onClick={() => onPick(v)} data-testid={`${testId}-${v}`}
        className="rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[11px] font-semibold text-slate-600 transition-colors hover:border-blue-700 hover:bg-blue-50 hover:text-blue-800 disabled:opacity-40">
        {v}%
      </button>
    ))}
  </div>
);

export const RoundToggle = ({ enabled, onChange, currency, testId, disabled = false }) => (
  <label className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs text-slate-600">
    <Switch checked={!!enabled} disabled={disabled} onCheckedChange={(v) => onChange(v)} data-testid={testId} />
    Bulatkan harga jual ke {currency === "USD" ? "1 USD" : "ribuan"} terdekat
  </label>
);
